import { render, staticRenderFns } from "./ScreenAmniocentese.vue?vue&type=template&id=391f0ca8&scoped=true&"
import script from "./ScreenAmniocentese.vue?vue&type=script&lang=js&"
export * from "./ScreenAmniocentese.vue?vue&type=script&lang=js&"
import style0 from "./ScreenAmniocentese.vue?vue&type=style&index=0&id=391f0ca8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391f0ca8",
  null
  
)

export default component.exports